import { CollapsibleTrigger } from '@radix-ui/react-collapsible';
import { Icon } from 'semantic-ui-react';
import { ProjectStorage } from '~/types/project';
import { formatNumber } from '~/utils';

export default function StorageFormHeader({
  storage,
  isCollapsed = false,
  onRemove,
}: {
  storage: ProjectStorage,
  isCollapsed: boolean,
  onRemove: () => void,
}) {
  const storageLabel =
    storage.wattage && storage.discharge
      ? ` - ${formatNumber(storage.wattage)} kW / ${formatNumber(storage.discharge)} kWh`
      : '';

  return (
    <div className="collapsible-card__header">
      <CollapsibleTrigger
        type="button"
        aria-label={isCollapsed ? 'Expand storage' : 'Collapse storage'}
        className="collapsible-card__trigger"
      >
        <span className="collapsible-card__caret">
          <Icon name={isCollapsed ? 'caret right' : 'caret down'} fitted />
        </span>
        <h3 className="collapsible-card__title">
          BESS {storage.order + 1}{storageLabel}
        </h3>
      </CollapsibleTrigger>
      <div className="collapsible-card__controls">
        <button
          type="button"
          aria-label="Remove storage"
          className="collapsible-card__remove"
          onClick={onRemove}
        >
          <Icon name="trash alternate outline" />
        </button>
      </div>
    </div>
  );
}
